export default __webpack_public_path__ + "static/media/amex_footer.d8feef21.png";